import Logo from "../../assets/images/docnote-logo.svg";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SignUpModal from "../../components/SignUpModal/SignUpModal";

const lovableURL = process.env.REACT_APP_LOVABLE_URL || "";
const navItems = [{ label: "Contact", href: "https://www.docnote.com/customer-support" }];
export function HomePageHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(true);
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const [signUpModalOpen, setSignUpModalOpen] = useState(false);
  const location = useLocation();

  const isActive = (href: string) => location.pathname === href;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setHasScrolled(currentScrollY > 0);

      // Hide banner when scrolling past 50px, only show again when back to top (< 10px)
      // This hysteresis prevents rapid toggling around the threshold
      if (!bannerDismissed) {
        if (currentScrollY > 50 && bannerVisible) {
          setBannerVisible(false);
        } else if (currentScrollY < 10 && !bannerVisible) {
          setBannerVisible(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [bannerDismissed, bannerVisible]);

  return (
    <div className="fixed w-[100%] top-0 z-50 bg-[#111C3D] component-home-page-header">
      {/* Announcement Banner */}

      {/* Main Header */}
      <header
        className={`transition-all duration-300 px-6 max-w-[80rem] mx-auto`}
        style={{ backgroundColor: location.pathname === "/for-patients" ? "#322642" : "#111C3D" }}
      >
        <div className="container-wide flex items-center justify-between h-14 md:h-16 relative px-4 md:px-0">
          {/* <Logo className="scale-90 md:scale-100" /> */}
          {lovableURL ? (
            <a href={lovableURL} className="flex items-center space-x-2">
              <img src={Logo} alt="Docnote Logo" className="h-6 " />
            </a>
          ) : (
            <Link to="/" className="flex items-center space-x-2">
              <img src={Logo} alt="Docnote Logo" className="h-6" />
            </Link>
          )}

          {/* Desktop Navigation - Centered */}
          <nav className="hidden md:flex items-center gap-0 lg:gap-0.5 absolute left-1/2 -translate-x-1/2">
            {navItems.map(item => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-2 lg:px-3 py-1.5 lg:py-2 text-xs lg:text-sm rounded-lg transition-colors ${
                  isActive(item.href)
                    ? "text-white font-bold bg-white/10 tracking-normal"
                    : "text-white hover:text-white/80 font-normal tracking-wide"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="hidden md:flex items-center gap-2 lg:gap-3">
            <Link
              to="/login"
              className="text-sm text-[#1d2a4e] bg-white px-4 h-9 flex items-center font-semibold rounded-[0.1875rem] tracking-[-0.16px]
          "
            >
              {" "}
              Log In
            </Link>
            <button
              onClick={() => setSignUpModalOpen(true)}
              className="text-sm text-white bg-[#e03100] px-4 h-9 flex items-center font-semibold rounded-[0.1875rem] cursor-pointer hover:bg-[#c72a00] transition-colors tracking-[-0.16px]"
            >
              Sign Up
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex md:hidden">
            <div className="flex items-center gap-2 md:hidden">
              <Link
                to={`/login`}
                className="md:hidden text-white  px-2 h-[30px] rounded-[20px] text-[14px] font-semibold
 flex items-center"
              >
                Login
              </Link>
              <button
                onClick={() => setSignUpModalOpen(true)}
                className="md:hidden text-white  px-2 py-[5px] bg-[#e03100] h-[30px] rounded-[20px] text-[14px] font-semibold
 flex items-center"
              >
                Sign Up
              </button>
            </div>
            <button className="md:hidden p-2 text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? (
                <div className="w-6 h-6">
                  <CloseIcon />
                </div>
              ) : (
                <div className="w-6 h-6">
                  <MenuIcon />
                </div>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div
            className="md:hidden border-t border-white/10 p-4 pb-6 rounded-b-2xl shadow-lg"
            style={{ backgroundColor: location.pathname === "/for-patients" ? "#322642" : "#111C3D" }}
          >
            <nav className="flex flex-col gap-2">
              {navItems.map(item => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-4 py-3 text-sm rounded-lg transition-colors ${
                    isActive(item.href) ? "text-white font-bold" : "text-white hover:text-white/80 font-normal"
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </header>

      {/* Sign Up Modal */}
      <SignUpModal open={signUpModalOpen} onClose={() => setSignUpModalOpen(false)} />
    </div>
  );
}
export default HomePageHeader;
